import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/progressive-web/why-choose-pwa.webp";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2 style={{ color: "#fff" }}>
              Why Choose TekRevol for Progressive Web App Development Services?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-3 mt-md-0">
            <p style={{ color: "#fff" }}>
              As a leading progressive web app development company, TekRevol is
              a pioneer in PWAs and it has gained significant attention through
              its high-performing applications that blend the best of web and
              mobile experiences.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>Demonstrated Skills in PWA Development</h5>
                    <p>
                      TekRevol’s experience in PWA development enables us to
                      focus on hybrid application development which gets the
                      best out of web and mobile application technologies while
                      rendering user engagement on your app wherever they go.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>Creative Approaches and Modern Technologies</h5>
                    <p>
                      Our company takes advantage of the most up-to-date PWA
                      solutions and frameworks to create high-performing
                      applications with rich features and fresh UI.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>Adapted to the Demands of Your Business</h5>
                    <p>
                      We help design PWAs for your business as per your business
                      needs and objectives, working for you and not against you,
                      and boosting your online presence.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Passion for User Satisfaction</h5>
                    <p>
                      User experience is a primary focus for us at TekRevol. We
                      ensure that your users access PWA regardless of the device
                      and platform being used.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>Handle Performance Under Load</h5>
                    <p>
                      We design our PWAs in such a way that makes them
                      responsive to all loads without failures and maintains the
                      same great user experience provided towards the end of
                      business growth.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Possibilities for Further Interactivity with the PWA
                    </h5>
                    <p>
                      We make sure that your PWA works within the infrastructure
                      or processes that you currently use seamlessly without any
                      lags or glitches whatsoever.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
